module.exports = __webpack_public_path__ + "img/1481721177.44fcf6db.jpg";